
/* Archivo para personalizar el Header del Login */
import { View, Image, useTheme } from "@aws-amplify/ui-react";
import { AuthenticatorProps } from "@aws-amplify/ui-react";
import logoUmmIA from "./img/logo-Ummia.svg";

export const AuthenticatorComps: AuthenticatorProps["components"] = {
  Header() {
    const { tokens } = useTheme();

    return (
      <View textAlign="center" padding={tokens.space.large}>
        <Image
          width={["100px", "130px", "150px"]}
          alt="Logo UMMIA"
          src={logoUmmIA}
        />
      </View>
    );
  },
};
